<script>

import { status } from "./status.js";
import page from "page";
import { fancyAlert, fancyConfirm } from "./notification.js";
import { deleteUser, deleteSubscription } from "./apihandler.js";
import { tl } from "./multilang.js";


let subscription;

async function killSubscription() {
    if (await fancyConfirm(tl("Confirm deletion of your subscription, services and users"))) {
        
        try {
            for (let i = 0; i < $status.subscription.users.length; i++) {
                let userId = $status.subscription.users[i].user;
                let service = $status.subscription.users[i].service;
                let userService = `${$status.subscription.id}_${service}`;
                let authKey = $status.subscription.services.find(i => i.name == service).adminAuthKey;

                await deleteUser(userId, userService, authKey);
            }
            
            $status.subscription.users=[];
            
            let id = $status.subscription.id;
            let code = $status.subscription.sessionAuth;

            await deleteSubscription(id, code);

            await fancyAlert(tl("Subscription deleted"));
            page("/");
            $status.subscription = {};
            $status.loggedIn = false;
        }
        catch (error) {
            if (error == 403) {
                await fancyAlert(tl("Your session expired, please log in again", tl("Session expired")));
                $status.loggedIn = false;
                $status.subscription = {};
                page("/");
            }
            else if (error == 490) {
                await fancyAlert(tl("Please open you administrative token in the ZofToken app and retry when ready", tl("Open your token")));
            }
            else {
                await fancyAlert(error, tl("Error"));
            }
        }
    }
    else {
        page("/");
    }
}

</script>

<style type="text/css">
.hero.is-danger {
    max-width: 70rem;
    margin: 2rem auto;
}
</style>

<section class=" has-background-grey-lightest ">
  <div class="container content">

    <div class="hero is-danger">
      <div class="hero-body">
        <div class="container">
          <h1 class="title is-1 has-text-centered has-text-weight-semibold">{tl("Warning")}</h1>
          <h4 class="title is-4 has-text-centered has-text-weight-normal">{tl("This will delete all users and services from this subscription rendering existing tokens inoperable")}</h4>
        </div>
      </div>
    </div>

    <div class="columns is-centered content">
  <div class="column is-one-third">
    <div class="box ">
      <h5>{tl("Type your subscription name to continue")}</h5>

      <div class="field">
        <div class="control">
          <input
            class="input"
            type="text"
            bind:value={subscription} />
        </div>
        <p class="help">{tl("You will also need your administrative ZoftToken to be open which will then be deleted")}</p>
      </div>

      <div>
        <button 
            class="button is-link" 
            on:click={killSubscription}
            disabled={subscription != $status.subscription.id}> 
          {tl("Delete")}
        </button>
        <button
          class="button"
          on:click={() => page('/')}>
          {tl("Cancel")}
        </button>
      </div>

    </div>

  </div>

</div>

  </div>
</section>
